import { Facsimile } from "../../types"
import * as yup from "yup"

export function initialValuesFacsimile(facsimile?: Facsimile | undefined) {
  if (facsimile) {
    return facsimile
  }
  return {
    edizione: undefined,
    titolo: "",
    descrizione: "",
  }
}

export function validationSchemaFacsimile(showEdizione: boolean) {
  if (showEdizione) {
    return yup.object().shape({
      edizione: yup.number().required("Campo obbligatorio"),
      titolo: yup.string().required("Campo obbligatorio"),
    })
  }
  return yup.object().shape({
    titolo: yup.string().required("Campo obbligatorio"),
  })
}
